import React, { FC } from 'react'

import Text, { TextProps } from './Text'

const Title: FC<TextProps> = ({ children, ...rest }) => {
  return (
    <Text variant="h1" color="textSecondary" {...rest}>
      {children}
    </Text>
  )
}

export default Title
